import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ChannelMatrix from "./components/ChannelMatrix";
import ArticleScroll from "./components/ArticleScroll";
import ReviewWall from "./components/ReviewWall";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <ChannelMatrix />
      <ArticleScroll />
      <ReviewWall />
      <CTASection />
      <Footer />
    </main>
  );
}